import React from 'react';

// Varyasyon 1: Minimalist Trend Çizgisi
export const LogoVariant1 = ({ size = 40, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 48 48" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Arka plan */}
    <rect width="48" height="48" rx="10" fill="#0D1117"/>
    
    {/* Ana trend çizgisi - yukarı yönlü */}
    <path 
      d="M8 32 L16 28 L24 20 L32 24 L40 12" 
      stroke="#00E599" 
      strokeWidth="3.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Ok ucu */}
    <path 
      d="M36 10 L40 12 L38 16" 
      stroke="#00E599" 
      strokeWidth="3" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Alt çizgi - destek seviyesi */}
    <path 
      d="M8 38 L40 38" 
      stroke="#1E293B" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
  </svg>
);

// Varyasyon 2: Gradient Trend Logo
export const LogoVariant2 = ({ size = 40, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 48 48" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient id="trendGradient" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#00E599" />
        <stop offset="100%" stopColor="#10B981" />
      </linearGradient>
      <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0F172A" />
        <stop offset="100%" stopColor="#1E293B" />
      </linearGradient>
    </defs>
    
    {/* Arka plan */}
    <rect width="48" height="48" rx="12" fill="url(#bgGradient)"/>
    
    {/* Glow efekti */}
    <path 
      d="M10 34 L18 26 L26 30 L38 14" 
      stroke="#00E599" 
      strokeWidth="8" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
      opacity="0.2"
    />
    
    {/* Ana trend çizgisi */}
    <path 
      d="M10 34 L18 26 L26 30 L38 14" 
      stroke="url(#trendGradient)" 
      strokeWidth="3.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Veri noktaları */}
    <circle cx="10" cy="34" r="2.5" fill="#00E599"/>
    <circle cx="18" cy="26" r="2.5" fill="#00E599"/>
    <circle cx="26" cy="30" r="2.5" fill="#00E599"/>
    <circle cx="38" cy="14" r="3" fill="#00E599"/>
  </svg>
);

// Varyasyon 3: Modern B + Trend
export const LogoVariant3 = ({ size = 40, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 48 48" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient id="greenGlow" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#00E599" stopOpacity="0.8"/>
        <stop offset="100%" stopColor="#00E599" stopOpacity="1"/>
      </linearGradient>
    </defs>
    
    {/* Arka plan */}
    <rect width="48" height="48" rx="10" fill="#0A0F14"/>
    
    {/* İç çerçeve */}
    <rect x="3" y="3" width="42" height="42" rx="8" stroke="#1E293B" strokeWidth="1" fill="none"/>
    
    {/* Trend çizgisi - keskin yukarı */}
    <path 
      d="M8 36 L20 28 L28 32 L40 12" 
      stroke="url(#greenGlow)" 
      strokeWidth="4" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Yukarı ok */}
    <polygon 
      points="40,12 34,16 36,20" 
      fill="#00E599"
    />
  </svg>
);

// Varyasyon 4: Ultra Minimalist
export const LogoVariant4 = ({ size = 40, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 48 48" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Arka plan - koyu */}
    <rect width="48" height="48" rx="8" fill="#0D1117"/>
    
    {/* Tek çizgi trend - güçlü yukarı */}
    <path 
      d="M6 38 L24 24 L42 8" 
      stroke="#00E599" 
      strokeWidth="5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// Varyasyon 5: Profesyonel Çizgi Grafiği
export const LogoVariant5 = ({ size = 40, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 48 48" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <linearGradient id="areaFill" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#00E599" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#00E599" stopOpacity="0"/>
      </linearGradient>
    </defs>
    
    {/* Arka plan */}
    <rect width="48" height="48" rx="10" fill="#080A0C"/>
    
    {/* Alan dolgusu */}
    <path 
      d="M6 36 L14 30 L22 32 L30 22 L38 16 L42 10 L42 40 L6 40 Z" 
      fill="url(#areaFill)"
    />
    
    {/* Ana çizgi */}
    <path 
      d="M6 36 L14 30 L22 32 L30 22 L38 16 L42 10" 
      stroke="#00E599" 
      strokeWidth="3" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Parlak nokta - en yüksek */}
    <circle cx="42" cy="10" r="4" fill="#00E599" opacity="0.3"/>
    <circle cx="42" cy="10" r="2" fill="#00E599"/>
  </svg>
);

// Ana Logo - Varsayılan olarak Varyasyon 2 kullanılacak
const BorsamexLogo = ({ size = 40, variant = 2, className = '' }) => {
  switch(variant) {
    case 1: return <LogoVariant1 size={size} className={className} />;
    case 2: return <LogoVariant2 size={size} className={className} />;
    case 3: return <LogoVariant3 size={size} className={className} />;
    case 4: return <LogoVariant4 size={size} className={className} />;
    case 5: return <LogoVariant5 size={size} className={className} />;
    default: return <LogoVariant2 size={size} className={className} />;
  }
};

export default BorsamexLogo;
